/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import type { FilterLabelDTO } from "./FilterLabelDTO";
import { FilterLabelDTOFromJSON, FilterLabelDTOFromJSONTyped, FilterLabelDTOToJSON } from "./FilterLabelDTO";
import type { FilterTypeDTO } from "./FilterTypeDTO";
import { FilterTypeDTOFromJSON, FilterTypeDTOFromJSONTyped, FilterTypeDTOToJSON } from "./FilterTypeDTO";

/**
 *
 * @export
 * @interface CreateFilterDTO
 */
export interface CreateFilterDTO {
  /**
   *
   * @type {string}
   * @memberof CreateFilterDTO
   */
  name: string;
  /**
   *
   * @type {FilterTypeDTO}
   * @memberof CreateFilterDTO
   */
  type: FilterTypeDTO;
  /**
   *
   * @type {FilterLabelDTO}
   * @memberof CreateFilterDTO
   */
  label?: FilterLabelDTO;
  /**
   *
   * @type {number}
   * @memberof CreateFilterDTO
   */
  usageByMerchant?: number;
  /**
   *
   * @type {number}
   * @memberof CreateFilterDTO
   */
  usageByDeals?: number;
}

/**
 * Check if a given object implements the CreateFilterDTO interface.
 */
export function instanceOfCreateFilterDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "type" in value;

  return isInstance;
}

export function CreateFilterDTOFromJSON(json: any): CreateFilterDTO {
  return CreateFilterDTOFromJSONTyped(json, false);
}

export function CreateFilterDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateFilterDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    name: json["name"],
    type: FilterTypeDTOFromJSON(json["type"]),
    label: !exists(json, "label") ? undefined : FilterLabelDTOFromJSON(json["label"]),
    usageByMerchant: !exists(json, "usageByMerchant") ? undefined : json["usageByMerchant"],
    usageByDeals: !exists(json, "usageByDeals") ? undefined : json["usageByDeals"]
  };
}

export function CreateFilterDTOToJSON(value?: CreateFilterDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    name: value.name,
    type: FilterTypeDTOToJSON(value.type),
    label: FilterLabelDTOToJSON(value.label),
    usageByMerchant: value.usageByMerchant,
    usageByDeals: value.usageByDeals
  };
}
